<template>
    <div>
        <h1 class="title">Créer une agence</h1>
        <div class="card white">
            <h2>Détails de l'agence</h2>
            <div class="form-group">
                <div class="form-control">
                    <label for="name">Nom*</label>
                    <input type="text" id="name" v-model="name" required />
                </div>
                <div class="form-control">
                    <label for="siret">Siret*</label>
                    <input type="text" id="siret" v-model="siret" required />
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label for="email">Email*</label>
                    <input type="email" id="email" v-model="email" required />
                </div>
                <div class="form-control">
                    <label for="address">Adresse*</label>
                    <input type="text" id="address" v-model="address" required />
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label for="telephone">Téléphone</label>
                    <input type="text" id="telephone" v-model="telephone" />
                </div>
                <div class="form-control">
                    <label for="mobile">Mobile</label>
                    <input type="text" id="mobile" v-model="mobile" />
                </div>
            </div>
            <div v-if="errorMessage" class="message">{{ errorMessage }}</div>
            <button type="submit" class="button fill normal" :disabled="isSubmitting" @click="submitForm">
                Ajouter
            </button>
        </div>
    </div>
</template>


<script>

export default {
    name: 'AjouterCompte',
    data() {
        return {
            email: "",
            name: "",
            siret: "",
            address: "",
            telephone: "",
            mobile: "",
            isSubmitting: false,
            errorMessage: "",
        };
    },
    methods: {
        async submitForm() {
            if (!this.email || !this.name || !this.siret || !this.address) return this.errorMessage = " Veuillez remplir tout les champs.";

            try {
                this.isSubmitting = true;
                this.errorMessage = "";

                const body = JSON.stringify({
                    email: this.email,
                    name: this.name,
                    siret: this.siret,
                    address: this.address,
                    telephone: this.telephone,
                    mobile: this.mobile,
                });
                const response = await fetch(process.env.VUE_APP_API_URL + "admin/agency/add", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: 'include', body, });

                if (response.ok) {
                    window.location.reload();
                } else {
                    const errorData = await response.json();
                    this.errorMessage = errorData.message
                        || "Erreur lors de la soumission des données. Veuillez réessayer.";
                }
            } catch (error) {
                console.error("Erreur lors de la soumission du formulaire:", error);
                this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
            } finally {
                this.isSubmitting = false;
            }
        },
    },
}
</script>

<style>
.form-control.agency {
    position: relative;
}
</style>